import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import QrLanding from "./pages/QrLanding";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/privacy" component={PrivacyPolicy} exact />
        <Route path="/auth/google/landing/success" component={QrLanding} />
        <Route path="/Claim" component={QrLanding} />
        <Route path="/claim" component={QrLanding} />
      </Switch>
    </Router>
  );
}

export default App;
